<template>
  <div>
    <navigation-bar />

    <div class="SIGNUP-CONTENT container fluid mt-5">
      <div class="row">
        <!-- Info area -->
        <div class="col-lg-8 col-md-10 pr-lg-0">
          <div class="SIGNUP flex-column d-flex py-3">
            <div class="container fluid">
              <div class="row">
                <div class="col px-4">
                  <div class="box p-4 text-secondary br5">
                    <div class="text-center" v-html="h1Title">
                      {{ h1Title }}
                    </div>
                    <div class="text-center mb-4" v-html="h2Title">
                      {{ h2Title }}
                    </div>
                    <div v-html="content">{{ content }}</div>
                  </div>
                </div>
              </div>
              <div v-html="bgImg">{{ bgImg }}</div>
              <!-- Sample image -->
              <!-- <div class="row d-none d-lg-block">
                <div
                  style="
                    background-image: url('https://test.tasracing.com.au/wp-content/uploads/2021/05/Burst-MasterJoin-Page-846-x-300px-FLT2.png');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    min-height: 300px;
                  "
                />
              </div> -->
            </div>
          </div>
        </div>

        <!-- Signup form -->
        <div class="col-lg-4 col-md-10 pl-lg-0">
          <!-- Stage 1-->
          <div class="SIGNUP flex-column d-flex py-3" v-if="stage === 1">
            <div class="container">
              <div class="row justify-content-center">
                <div
                  class="col px-0"
                  style="box-shadow: 0px 0px 0px 20px #1e2e36 !important"
                >
                  <div
                    class="
                      box
                      bg-dark
                      border border-light
                      p-4
                      text-center text-secondary
                    "
                  >
                    <div class="logo-div mb-5">
                      <a :href="config.tasracingWebsite">
                        <div v-html="logoImg">
                          {{ logoImg }}
                        </div>
                      </a>
                    </div>

                    <p class="color-menu px-lg-5">
                      <span
                        >Access to FORMPLUS PRO is just a few simple steps
                        away.</span
                      >
                      <br />
                      <br />
                      <strong class="text-white signup-free"
                        >Sign up for FREE.</strong
                      >
                    </p>
                    <p><i>Must be over 18 years of age.</i></p>
                    <form
                      @submit.prevent="handleInitialJoin"
                      class="form-group m-0 mt-2"
                    >
                      <label class="color-menu" for="email"
                        >Enter your email below</label
                      >
                      <input
                        class="
                          form-control
                          bg-white
                          mx-auto
                          mt-2
                          br0
                          py-0
                          text-dark
                          border-0
                        "
                        id="email"
                        required
                        type="email"
                        v-model="postData.email"
                        style="width: 90%; height: 32px"
                      />
                      <button
                        class="
                          btn btn-success
                          br10
                          border-0
                          text-center text-uppercase
                          py-1
                          px-5
                          fz20
                          mt-3
                          text-dark
                        "
                        style="background-color: #f0ca14; font-weight: 800"
                      >
                        Join now
                      </button>
                    </form>
                    <b-alert :show="errorMessage" class="mt-2" variant="danger"
                      >{{ errorMessage }}
                    </b-alert>
                    <p class="m-0 mt-3 text-uppercase">
                      Already have an account?
                    </p>
                    <p class="m-0 mt-1" style="font-size: 16px">
                      <router-link
                        class="text-white text-uppercase fwb"
                        to="/signin"
                      >
                        Sign in
                      </router-link>
                    </p>
                    <img
                      alt=""
                      class="img-fluid d-block mx-auto my-2"
                      src="img/or.png"
                    />
                    <button @click.prevent="facebookSignIn" class="btn m-0 p-0">
                      <img alt="" class="img-fluid" src="img/fb.png" />
                    </button>
                    <button @click.prevent="googleSignIn" class="btn mt-1 p-0">
                      <img alt="" class="img-fluid" src="img/go.png" />
                    </button>
                    <a :href="twitterAuthUrl" class="btn mt-1 p-0">
                      <img alt="" class="img-fluid" src="img/tw.png" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Stage 2-->
          <div
            class="SIGNUP justify-content-center flex-column d-flex py-3"
            v-if="stage === 2"
          >
            <div class="container">
              <div class="row justify-content-center">
                <div class="col">
                  <div class="box bg-dark p-4 text-secondary br5">
                    <div class="text-right">
                      <b-button
                        @click.prevent="stage = 1"
                        class="text-secondary fz12"
                        size="sm"
                        variant="link"
                      >
                        <i class="fa fa-arrow-left"></i> Back
                      </b-button>
                    </div>
                    <h3 class="fw6 text-center color-menu">Account Details</h3>
                    <form
                      @input.prevent="handleSignUpFormDataChange"
                      @submit.prevent="handleJoin"
                      class="form-group m-0 mt-4"
                      method="post"
                    >
                      <div class="text-center mb-3">
                        <label
                          class="fw6 text-uppercase color-menu"
                          for="email2"
                          >EMAIL</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="email2"
                          type="email"
                          required
                          v-model="postData.email"
                        />

                        <label class="fw6 text-uppercase color-menu" for="fname"
                          >FIRST NAME</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="fname"
                          required
                          type="text"
                          v-model="postData.firstName"
                        />

                        <label class="fw6 text-uppercase color-menu" for="lname"
                          >LAST NAME</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="lname"
                          required
                          type="text"
                          v-model="postData.lastName"
                        />

                        <label
                          class="fw6 text-uppercase color-menu"
                          for="password"
                          >PASSWORD</label
                        >
                        <div class="input-group mb-3">
                          <input
                            :minlength="config.minPasswordLength"
                            :type="viewPassword ? 'text' : 'password'"
                            aria-describedby="button-addon2"
                            aria-label="Recipient's username"
                            class="
                              form-control
                              bg-dark1
                              br3
                              py-4
                              text-white
                              border-0
                            "
                            id="password"
                            required
                            v-model="postData.password"
                          />
                          <div class="input-group-append">
                            <button
                              @click.prevent="viewPassword = !viewPassword"
                              class="
                                btn btn-sm btn-outline-secondary
                                border-0
                                bg-dark1
                              "
                              id="button-addon2"
                              type="button"
                            >
                              <i
                                :class="
                                  viewPassword ? 'fa fa-eye' : 'fa fa-eye-slash'
                                "
                              ></i>
                            </button>
                          </div>
                        </div>

                        <label class="fw6 text-uppercase color-menu" for="dob"
                          >date of birth (DD/MM/YYYY)</label
                        >
                        <input
                          required
                          class="bg-dark1 text-white border-0 form-control mb-2"
                          id="dob"
                          type="text"
                          v-model="postData.dob"
                        />

                        <label
                          class="fw6 text-uppercase color-menu"
                          for="postcode"
                          >ADDRESS 1</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="address-1"
                          required
                          type="text"
                          v-model="postData.addressOne"
                        />

                        <label
                          class="fw6 text-uppercase color-menu"
                          for="postcode"
                          >ADDRESS 2</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="address-2"
                          required
                          type="text"
                          v-model="postData.addressTwo"
                        />

                        <label
                          class="fw6 text-uppercase color-menu"
                          for="postcode"
                          >POSTCODE</label
                        >
                        <input
                          class="
                            form-control
                            bg-dark1
                            br3
                            py-4
                            text-white
                            border-0
                            mb-2
                          "
                          id="postcode"
                          maxlength="4"
                          required
                          type="text"
                          v-model="postData.postCode"
                        />

                        <!-- TO-DO ON-HOLD ladbroke  -->
                        <div class="d-none">
                          <label
                            class="fw6 text-uppercase color-menu"
                            for="postcode"
                            >Ladbroke Username</label
                          >
                          <input
                            class="
                              form-control
                              bg-dark1
                              br3
                              py-4
                              text-white
                              border-0
                              mb-2
                            "
                            id="postcode"
                            maxlength="4"
                            type="text"
                            v-model="postData.ladbrokeUsername"
                          />
                        </div>
                      </div>

                      <div class="d-flex justify-content-center">
                        <vue-recaptcha
                          :loadRecaptchaScript="true"
                          :sitekey="config.gReCaptchaV2SiteKey"
                          @expired="expiredCaptcha"
                          @verify="verifyCaptcha"
                          id="recaptcha-v2"
                          ref="recaptcha"
                          size="normal"
                          theme="dark"
                        >
                        </vue-recaptcha>
                      </div>

                      <b-form-checkbox-group
                        id="checkboxes-4"
                        v-model="checked"
                      >
                        <b-form-checkbox class="my-1" value="tnc">
                          I accept the
                          <a
                            class="tnc-link"
                            href="https://tasracing.com.au/website-terms-use/"
                            target="_blank"
                            >terms and conditions</a
                          >
                        </b-form-checkbox>
                        <br />
                        <b-form-checkbox class="my-1 color-menu" value="news"
                          >Subscribe to Tasracing's data-driven newsletter
                        </b-form-checkbox>
                        <br />
                        <b-form-checkbox
                          class="my-1 color-menu"
                          value="third_party"
                          >I am willing to receive third party marketing from
                          wagering providers including email, SMS and other
                          forms of communication
                        </b-form-checkbox>
                      </b-form-checkbox-group>

                      <b-alert :show="error" class="my-1" variant="danger">{{
                        error
                      }}</b-alert>

                      <b-button
                        :disabled="registering"
                        class="
                          btn btn-success
                          bg-success
                          br3
                          border-0
                          text-uppercase
                          font-weight-bold
                          py-2
                          fz20
                          d-block
                          w-100
                          mt-3
                        "
                        type="submit"
                      >
                        <b-spinner
                          class="v-align-txt-baseline"
                          small
                          v-if="registering"
                        ></b-spinner>
                        {{ registering ? "submitting" : "submit" }}
                      </b-button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Stage 3-->
          <div
            class="SIGNUP justify-content-center flex-column d-flex py-3"
            v-if="stage === 3"
          >
            <div class="container">
              <div class="row justify-content-center">
                <div class="col">
                  <div class="box bg-dark p-4 text-secondary br5 text-center">
                    <h3 class="text-uppercase font-weight-bold mb-3">
                      Confirmation Email Sent
                    </h3>
                    <p class="color-dark">
                      Click the confirmation link in your email to take the next
                      step of creating your account.
                    </p>
                    <p class="color-dark mb-2">
                      Can't find your email? <br />Check your spam or junk
                      folder.
                    </p>
                    <router-link
                      class="
                        btn btn-success
                        bg-success
                        br3
                        border-0
                        text-uppercase
                        font-weight-bold
                        py-2
                        fz20
                        d-block
                        w-100
                        mt-3
                      "
                      to="/signin"
                    >
                      continue
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/config";
import { GetMeAndHandleRedirect, setRedirectUrl, apiUrl } from "@/commons";
import { Auth } from "aws-amplify";
import VueRecaptcha from "vue-recaptcha";
import NavigationBar from "../commons/NavigationBar";

export default {
  name: "Signup",
  components: { NavigationBar, VueRecaptcha },
  data() {
    return {
      stage: 1,
      postData: {},
      checked: ["news", "third_party"],
      error: null,
      registering: false,
      viewPassword: false,
      errorMessage: null,
      captchaToken: null,
      h1Title: "",
      h2Title: "",
      content: "",
      logoImg: "",
      bgImg: "",
      ipAddress: "",
    };
  },
  async mounted() {
    const query = this.$route.query;
    if (query && query.redirect) {
      setRedirectUrl(query.redirect);
    }

    if (query && query.error_description) {
      let errorDesc = query.error_description;
      errorDesc = errorDesc.replace("PreSignUp failed with error", "");
      errorDesc = errorDesc.replace(
        "PreSignUp invocation failed due to error",
        ""
      );
      errorDesc = errorDesc.replace("PreAuthentication failed with error", "");
      this.errorMessage = errorDesc;
    }

    var res = await fetch(`${apiUrl}/systemsettings/signup-settings`);
    var resData = await res.json();

    if (this.$route.query.promotion === "true") {
      this.h1Title = resData.data.find(
        (d) => d.key === "Promo_Signup_H1"
      ).value;
      this.h2Title = resData.data.find(
        (d) => d.key === "Promo_Signup_H2"
      ).value;
      this.content = resData.data.find(
        (d) => d.key === "Promo_Signup_Content"
      ).value;
      this.logoImg = resData.data.find(
        (d) => d.key === "Promo_Signup_Logo"
      ).value;
      this.bgImg = resData.data.find((d) => d.key === "Promo_Signup_IMG").value;
    } else {
      this.h1Title = resData.data.find((d) => d.key === "Signup_H1").value;
      this.h2Title = resData.data.find((d) => d.key === "Signup_H2").value;
      this.content = resData.data.find((d) => d.key === "Signup_Content").value;
      this.logoImg = resData.data.find((d) => d.key === "Signup_Logo").value;
      this.bgImg = resData.data.find((d) => d.key === "Signup_IMG").value;
    }

    res = await fetch(`${apiUrl}/apn/device/ipaddress`);
    resData = await res.json();

    this.postData.ipAddress = resData.data.ipAddress;

    GetMeAndHandleRedirect();
  },
  methods: {
    expiredCaptcha() {
      this.captchaToken = null;
      this.$refs.recaptcha.reset();
    },
    verifyCaptcha(token) {
      this.captchaToken = token;
    },
    handleSignUpFormDataChange() {
      this.error = null;
    },
    facebookSignIn() {
      Auth.federatedSignIn({ provider: "Facebook" });
    },
    googleSignIn() {
      Auth.federatedSignIn({ provider: "Google" });
    },
    handleInitialJoin() {
      this.stage = 2;
    },
    async handleJoin() {
      this.error = null;
      if (!this.captchaToken) {
        this.error = "Please check the captcha checkbox";
        return;
      }
      if (!this.checked.includes("tnc")) {
        this.error = "Please read and accept T&Cs";
        return;
      }

      if (!this.postData.password) {
        this.error = "Please enter password";
        return;
      } else if (this.postData.password.length < 8) {
        this.error = "Password must be of atleast 8 characters long";
        return;
      }

      if (isNaN(this.postData.postCode)) {
        this.error = "Please enter valid postcode";
        return;
      }

      if (!this.postData.dob) {
        this.error = "Please enter your date of birth";
        return;
      }

      if (!this.postData.dob) {
        this.error = "DOB is required";
        return;
      } else if (
        this.postData.dob.length !== 10 ||
        this.postData.dob.split("/").length !== 3
      ) {
        this.error = "Please enter DOB in DD/MM/YYYY format";
        return;
      } else {
        const dobMoment = moment(this.postData.dob, "DD/MM/YYYY");
        if (!dobMoment.isValid()) {
          this.error = "Please enter DOB in DD/MM/YYYY format";
          return;
        } else {
          const age = moment().diff(dobMoment, "years");
          if (age < 18) {
            this.error = "You must be over 18 to signup";
            return;
          } else if (age < 0 || age > 120) {
            this.error = "Invalid age";
            return;
          }
        }
      }

      this.registering = true;

      try {
        const signupResult = await Auth.signUp({
          username: this.postData.email.toLowerCase(),
          password: this.postData.password,
          attributes: {
            given_name: this.postData.firstName,
            family_name: this.postData.lastName,
            birthdate: this.postData.dob,
            "custom:postcode": this.postData.postCode,
            "custom:address1": this.postData.addressOne,
            "custom:address2": this.postData.addressTwo,
            //"custom:ladbrokeId": this.postData.ladbrokeUsername,
            "custom:ipAddress": this.postData.ipAddress,
          },
          validationData: [
            { Name: "re_captcha_token", Value: this.captchaToken },
            { Name: "newsletter", Value: `${this.checked.includes("news")}` },
            {
              Name: "third_party",
              Value: `${this.checked.includes("third_party")}`,
            },
          ],
        });
        const cognitoUser = signupResult.user;
        if (cognitoUser) {
          this.stage = 3;
        }
      } catch (err) {
        this.error = err.message;
      }
      this.registering = false;
    },
  },
  computed: {
    config() {
      return config;
    },
    maxDate() {
      return moment().subtract(18, "years").format("YYYY-MM-DD");
    },
    minDate() {
      return moment().subtract(118, "years").format("YYYY-MM-DD");
    },
    initialNotificationPreferenceUrl() {
      return "/initial-notification-settings";
    },
    twitterAuthUrl() {
      const url = config.twitterAuthUrl;
      return `${url}?redirect=${window.location.href}`;
    },
    bgCss() {
      return {
        width: "100%",
        "min-height": "95vh",
        position: "absolute",
        "z-index": -1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tnc-link {
  text-decoration: underline;
  color: #b4c2ca !important;
}

.color-dark {
  font-size: 0.8em;
  color: #b4c2ca !important;
}

.custom-date {
  width: 100%;
}

#recaptcha-v2 {
  //margin: auto;
  /*transform: scale(0.9);
        transform-origin: 0 0;
        @media screen and (min-width: 768px) {
            transform: scale(0.85);
        }*/
}

.rc-anchor-dark {
  background-color: red !important;
}

.logo-div {
  margin-top: auto;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.promotion-img {
  min-height: 300px;
}

@media (min-width: 1200px) {
  .SIGNUP-LOGO.container {
    max-width: 1140px !important;
  }
  .SIGNUP-CONTENT.container {
    max-width: 70% !important;
  }
}

.logo-link {
  width: 200px !important;
}

.signup-free {
  font-size: 1.5rem;
}
</style>
